import React from 'react';

interface ModalHeaderProps {
  children: React.ReactNode;
  onClose: () => void;
}

export const ModalHeader = ({ children, onClose }: ModalHeaderProps) => {
  return (
    <div className="modal-header">
      <button type="button" className="close" onClick={onClose}>
        <span aria-hidden="true">×</span>
      </button>
      <h4 className="modal-title">{children}</h4>
    </div>
  );
};
